export default function About() {
  return (
    <section id="about" className="py-24 bg-esthe-floral-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border-8 border-white shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/340bdc32ff9fbc7a4df95c89759c03ed.jpg"
                alt="Our Clinic"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div>
            <p className="text-esthe-light-bronze text-sm tracking-widest uppercase mb-4 font-medium">
              / OUR STORY
            </p>
            <h2 className="text-5xl font-serif mb-8 leading-tight text-esthe-cafe-noir">
              Redefining Beauty
              <br />
              Through Excellence
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="text-esthe-mocha leading-relaxed">
                <p className="mb-4">
                  Founded with a vision to provide exceptional aesthetic care, our clinic combines cutting-edge technology with personalized treatment plans tailored to your unique needs.
                </p>
                <p>
                  We believe that true beauty comes from confidence, and our mission is to help you look and feel your absolute best.
                </p>
              </div>
              <div className="text-esthe-mocha leading-relaxed">
                <p className="mb-4">
                  Our team of board-certified practitioners brings decades of combined experience in aesthetic medicine, ensuring safe, effective, and natural-looking results.
                </p>
                <p>
                  Every treatment is performed with meticulous attention to detail in our luxurious, state-of-the-art facility.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-esthe-pale-taupe">
              <div>
                <div className="text-6xl font-serif text-esthe-light-bronze mb-2">15+</div>
                <div className="text-sm text-esthe-mocha uppercase tracking-wide">Years Experience</div>
              </div>
              <div>
                <div className="text-6xl font-serif text-esthe-light-bronze mb-2">50K+</div>
                <div className="text-sm text-esthe-mocha uppercase tracking-wide">Happy Clients</div>
              </div>
              <div>
                <div className="text-6xl font-serif text-esthe-light-bronze mb-2">98%</div>
                <div className="text-sm text-esthe-mocha uppercase tracking-wide">Satisfaction Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
